import React, { useEffect, useState, useContext, useRef } from "react";
import { UserContext } from "../../App.js";
import StartStopIcon from "../../components/StartStopIcon.js";
import DiskUsage from "../../components/DiskUsage.js";
import DiskInfo from "../../components/DiskInfo.js";

const LogStatusBar = ({ socket, status, disk, isConnected,  lidarStatus }) => {
  const {
    timer,
    setTimer,
    buttonstr,
    setButtonstr,
    isrecording,
    setRecordingStatus,
    id,
    setIntervalId,
  } = useContext(UserContext);
  const [infoStatus, setDiskInfo] = useState(false);
  const [fontColor, SetfontColor] = useState("green");
  const [isdiskConnected, setIsConnected] = useState();
  const [usageInPercent, setUsageInPercent] = useState(0);
  const [lidarStatusCounts, setLidarStatusCounts] = useState({ okay: 0, notOkay: 0 });

  const intervalRef = useRef(null);

  function toggleinfostatus() {
    setDiskInfo((prevState) => (prevState = !prevState));
  }

  function toggle_record_button() {
    if (isrecording === false) {
      let start_time = Date.now();
      start_timer(start_time);
    } else {
      stop_timer();
    }
    socket.emit("TRIGGER_EVENT", {
      trigger_type: "STANDBY_ACTIVE",
    });

    let is_recording = !isrecording;
    setRecordingStatus(is_recording);
  }

  function start_timer(start_time) {
    intervalRef.current = setInterval(() => {
      let time_lapsed = Date.now() - start_time;
      let seconds = ("0" + (Math.floor(time_lapsed / 1000) % 60)).slice(-2);
      let minutes = ("0" + (Math.floor(time_lapsed / 60000) % 60)).slice(-2);
      let hours = ("0" + Math.floor(time_lapsed / 3600000)).slice(-2);
      let timer_string = hours + ":" + minutes + ":" + seconds;
      setTimer(timer_string);
    }, 1000);
    setButtonstr("Stop");
    setIntervalId(intervalRef.current);
  }

  function stop_timer() {
    clearInterval(id);
    setTimer("00:00:00");
    setButtonstr("Record");
  }

  // Calculate lidar statuses
  useEffect(() => {
    if (lidarStatus && lidarStatus.messages && lidarStatus.messages[0]) {
      const lidarMessages = lidarStatus.messages[0];
      let okayCount = 0;
      let notOkayCount = 0;

      for (const key in lidarMessages) {
        if (lidarMessages[key].status === true) {
          okayCount++;
        } else {
          notOkayCount++;
        }
      }

      setLidarStatusCounts({ okay: okayCount, notOkay: notOkayCount });
    } else {
      setLidarStatusCounts({ okay: 0, notOkay: 0 });
    }
  }, [lidarStatus]);

  useEffect(() => {
    if (status !== undefined) {
      setIsConnected(isConnected);
      setUsageInPercent(disk);

      if (status === "Ready") {
        SetfontColor("#00B29F");
      } else {
        SetfontColor("#EB0A37");
      }
    }
    return () => { };
  }, [status, isConnected, disk]);

  const infoIcon = (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.6 26C51.6 40.1385 40.1385 51.6 26 51.6C11.8615 51.6 0.399994 40.1385 0.399994 26C0.399994 11.8615 11.8615 0.399994 26 0.399994C40.1385 0.399994 51.6 11.8615 51.6 26ZM48.4 26C48.4 38.3712 38.3712 48.4 26 48.4C13.6288 48.4 3.59999 38.3712 3.59999 26C3.59999 13.6288 13.6288 3.59999 26 3.59999C38.3712 3.59999 48.4 13.6288 48.4 26Z"
        fill="#CCDBF0"
      />
      <path
        d="M28.0026 19.5793H24.0062V39.3136H28.0026V19.5793Z"
        fill="#CCDBF0"
      />
      <path
        d="M26 17.1746C27.3392 17.1746 28.4248 16.089 28.4248 14.7498C28.4248 13.4106 27.3392 12.325 26 12.325C24.6608 12.325 23.5752 13.4106 23.5752 14.7498C23.5752 16.089 24.6608 17.1746 26 17.1746Z"
        fill="#CCDBF0"
      />
    </svg>
  );

  return (
    <div className="flex  justify-between items-center text-light-1 bg-light-8 h-full px-[48px] py-[30px]">
      <div className="w-full items-center h-full border-r-2 border-light-5 py-[10px]">
        <div className="text-sm font-scaniacondensed"> System Status</div>
        <div
          className="text-xxl font-scaniacondensed leading-[64px]"
          style={{ color: fontColor }}
        >
          {status}
        </div>
      </div>
      <div className="relative w-full items-center h-full border-r-2 border-light-5 py-[10px] px-[48px]">
        <div className="flex justify-between">
    <div className="text-sm font-scaniacondensed">Sensor Status</div>
  </div>
  <div className="flex flex-col mt-4">
    {(() => {
      const total = Object.keys(lidarStatus?.messages?.[0] || {}).length;
      const percentage = total > 0 ? (lidarStatusCounts.okay / total) * 100 : 0;

      // Determine text color based on percentage
      let fontColor;
      if (percentage === 100) {
        fontColor = "#00B29F"; // Green for 100% okay
      }else {
        fontColor = "#EB0A37"; // Red for less than 50%
      }

      return (
        <div
          className="text-lg font-scaniacondensed"
          style={{ color: fontColor }}
        >
          Lidars: {lidarStatusCounts.okay}/{total}
        </div>
      );
    })()}
  </div>


      </div>
      <div className="relative w-full items-center h-full border-r-2 border-light-5 py-[10px] px-[48px]">
        <div className="flex justify-between">
          <div className="text-sm font-scaniacondensed">Disk Usage</div>
          <div className="z-50">
            <button
              className="absolute top-[-4px] right-5"
              onClick={() => toggleinfostatus()}
            >
              {infoIcon}
            </button>
          </div>
          <DiskInfo info={infoStatus} toggleinfostatus={toggleinfostatus} />
        </div>
        <div className="flex items-center">
          <DiskUsage
            usage_percentage={usageInPercent}
            isdiskConnected={isdiskConnected}
          />
        </div>
      </div>
      <div className="w-full items-center h-full py-[10px] px-[48px]">
        <div className="flex flex-col">
          <div className="text-sm font-scaniacondensed">Recording Time</div>
          <span className="text-light-1 text-xxl font-scaniacondensed leading-[64px]">
            {timer}
          </span>
        </div>
      </div>
      <div className="flex justify-end w-full h-full">
        <button
          className="flex justify-between items-center bg-dark-red disabled:bg-grey-868  text-white font-scaniacondensed px-[48px] py-[40px] rounded-[8px]"
          onClick={() => toggle_record_button()}
        /* Never disable record button */
        /* disabled={status !== "Ready" && buttonstr === "Record"}*/
        >
          {/* Always keeps the Record button red and active, no matter system status*/}
          <div
            className={`flex` /*${status !== "Ready" && buttonstr === "Record" ? "opacity-25" : ""
              }`*/}
          >
            <StartStopIcon state={buttonstr} />
            <span className="text-md pl-[24px]">{buttonstr}</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default LogStatusBar;
